import { AllocatorPageBulkAllocationsQuery } from '@/__generated__/graphql';

export enum AllocatorTabsEnum {
  BeginAllocation = 'Begin Allocation',
  InvestmentReview = 'Investment Review',
  AdvisorReview = 'Advisor Review',
  ComplianceReview = 'Compliance Review'
}

export enum AllocatorPageMode {
  VIEW = 'view',
  EDIT = 'edit'
}

export type GroupedLegalEntityCommittedCapital = {
  groupedEntityId: string;
  committedCapital: number;
};

export type ExtendedBulkAllocation = AllocatorPageBulkAllocationsQuery['bulkAllocations']['allocations'][number] & {
  checked: boolean;
  decisionReason: string;
  selectedGroupedLegalEntity: {
    id: string;
    entityName: string;
    committedCapital?: number;
    proposalType?: string;
  } | null;
};
